import React, { useState, useEffect, useRef } from "react";
import gmailicon from "../ulits/images/gmail-icon.svg";
import callicon from "../ulits/images/call-icon.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import arrowwhite from "../ulits/images/arrow_icon.svg";
import { configs } from "../config";
import arrowdrop from "../ulits/images/arrow-drop.svg";

function Header(props) {
  const [activeIndex, setActiveIndex] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [config, setConfig] = useState({});
  const [activeItem, setActiveItem] = useState();
  const [isShown, setIsShown] = useState(false);
  const [isEnabled, setIsEnabled] = useState(window.innerWidth >= 1520);
  const submenuRef = useRef(null);
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);
  const sidebarRef = useRef(null);

  const location = useLocation();
  const hiddenFooter = ["/print"];

  useEffect(() => {
    setConfig(props?.configData);
  }, [props?.configData]);

  const handleItemClick = (index) => {
    setActiveIndex(index);
  };

  const Dropdown = () => {
    setIsOpen(!isOpen);
  };

  const ToggleSidebar = () => {
    setIsOpen(!isOpen);
  };
  const handleDropdownClick = (item) => {
    setActiveItem((prev) => (prev === item ? "" : item));
  };

  const handleClickOutside = (event) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // const dispatch = useDispatch();
  // const configData = useSelector((state) => state.config);

  // useEffect(() => {
  //   dispatch(configAction.getConfigByTenantId());
  // }, []);

  // useEffect(() => {
  //   if (configData && configData.config_status === status.SUCCESS) {
  //     setConfig(configData.config_data);
  //     localStorage.setItem("config", JSON.stringify(configData.config_data));
  //   }
  // }, [configData.config_data]);

  useEffect(() => {
    const handleResize = () => {
      setIsEnabled(window.innerWidth >= 1024);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleEnter = () => isEnabled && setIsShown(true);
  const handleLeave = () => isEnabled && setIsShown(false);
  const handleClick = () => isEnabled && setIsShown((prev) => !prev);

  const arrowActivation = submenuRef.current?.closest(".nav-submenu")
    ? "x"
    : "y";

  if (hiddenFooter.includes(location.pathname)) return null;

  return (
    <div className="site-header">
      {config && Object.keys(config).length > 0 && (
        <>
          <div className="header-top">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-4 col-md-6 col-sm-6 col-xs-6 col-10">
                  <div className="header-top-left">
                    <Link to="/">
                      <img
                        src={`${configs.localApiUrl}${config?.Header_logo}`}
                        alt="header-logo"
                      />
                    </Link>
                  </div>
                </div>
                <div className="col-lg-5 col-md-6 col-sm-6 col-xs-6 col-2">
                  <div className="header-top-center">
                    <ul>
                      <li>
                        <Link
                          to="/car-listing"
                          className={activeIndex === "BUY" ? "active" : ""}
                          onClick={() => handleItemClick("BUY")}
                        >
                          current stock
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/sell"
                          className={activeIndex === "SELL" ? "active" : ""}
                          onClick={() => {
                            window.scrollTo(0, 0);
                            handleItemClick("SELL");
                          }}
                        >
                          sell your lhd car
                        </Link>
                      </li>
                      {/* <li>
                        <Link
                          to="#"
                          className={activeIndex === "MORE" ? "active" : ""}
                          onClick={() => handleItemClick("MORE")}
                        >
                          MORE
                        </Link>
                      </li> */}
                      <li className="dropdown">
                        <Link
                          to="#"
                          className={activeIndex === "MORE" ? "active" : ""}
                          onClick={() => handleItemClick("MORE")}
                        >
                          MORE
                        </Link>
                        <div className="dropdown-content">
                          <ul>
                            <div
                              className={`dropdown-wrapper ${isShown ? "class-shown" : ""
                                }`}
                              onMouseEnter={handleEnter}
                              onMouseLeave={handleLeave}
                            >
                              <li onClick={handleClick}>
                                <Link
                                  to="/about"
                                  className={
                                    activeIndex === "About" ? "active" : ""
                                  }
                                  onClick={() => handleItemClick("About")}
                                >
                                  About
                                </Link>
                                <img
                                  src={arrowdrop}
                                  alt="arrow"
                                  className="arrow-icon"
                                />
                              </li>

                              {isEnabled && (
                                <ul
                                  ref={submenuRef}
                                  className={`dropdown-menu ${isShown ? "class-shown" : ""
                                    }`}
                                >
                                  <li className="submenu">
                                    <Link to="/about-history">OUR HISTORY</Link>
                                  </li>
                                  <li className="submenu">
                                    <Link to="/about-choose">
                                      WHY CHOOSE US
                                    </Link>
                                  </li>
                                  <li className="submenu">
                                    <Link to="/about-testimonials">
                                      TESTIMONIALS
                                    </Link>
                                  </li>
                                </ul>
                              )}
                            </div>
                            <li>
                              <Link to="/contact">Contact Us</Link>
                            </li>
                            <li>
                              <Link to="/blog-listing">Blog Listing</Link>
                            </li>

                            <li className="dropdown2">
                              <Link
                                to="#"
                                className={
                                  activeIndex === "EUROPEAN HPI CHECKS"
                                    ? "active"
                                    : ""
                                }
                              >
                                EUROPEAN HPI
                              </Link>
                              <img
                                src={arrowdrop}
                                alt="arrow"
                                className="arrow-icon"
                              />
                              <div className="dropdown-content2">
                                <ul>
                                  <li>
                                    <Link to="/order-spanish">
                                      ORDER A SPANISH HPI CHECK
                                    </Link>
                                  </li>
                                  <li>
                                    <Link to="/order-french">
                                      ORDER A FRENCH HPI CHECK
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                            </li>

                            <li>
                              <Link to="/european-insurance">
                                EUROPEAN INSURANCE
                              </Link>
                            </li>
                            <li>
                              <Link to="/finance">FINANCE</Link>
                            </li>
                          </ul>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div className="sidebar">
                    <button
                      className={`menu-button ${isOpen == true ? "open" : ""}`}
                      onClick={ToggleSidebar}
                    >
                      <span></span>
                      <span></span>
                      <span></span>
                    </button>
                    <nav ref={sidebarRef} className={`menu ${isOpen == true ? "open" : ""}`}>
                      <div className="sd-header">
                        <Link to="/">
                          <img
                            src={
                              config &&
                              config.Footer_logo &&
                              `${configs.localApiUrl}${config?.Footer_logo}`
                            }
                            alt="footer-logo"
                            className="img-fluid"
                          />
                        </Link>
                        <div className="menu-close" onClick={ToggleSidebar}>
                          <img src={arrowwhite} alt="Close Menu" />
                        </div>
                      </div>
                      <div className="hide-desk">
                        <div className="meno-menu">
                          <div className="social-icon">
                            <ul className="list-unstyled">
                              <li>
                                <Link
                                  to={`mailto:${config && config.Support_Email
                                    }`}
                                >
                                  <img src={gmailicon} alt="" />
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to={`tel:${config && config?.Contact_Number}`}
                                >
                                  <img src={callicon} alt="" />
                                </Link>
                              </li>
                            </ul>
                          </div>
                          <ul className="mobo-menu">
                            {/* <li>
                              <Link
                                to="#"
                                className={
                                  activeIndex === "BUY" ? "active" : ""
                                }
                                onClick={() => {
                                  handleItemClick("BUY");
                                  ToggleSidebar();
                                }}
                              >
                                BUY
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="#"
                                className={
                                  activeIndex === "SELL" ? "active" : ""
                                }
                                onClick={() => {
                                  handleItemClick("SELL");
                                  ToggleSidebar();
                                }}
                              >
                                SELL
                              </Link>
                            </li> */}
                            {/* <li>
                              <Link
                                to="#"
                                className={
                                  activeIndex === "MORE" ? "active" : ""
                                }
                                onClick={() => {
                                  handleItemClick("MORE");
                                  ToggleSidebar();
                                }}
                              >
                                MORE
                              </Link>
                            </li> */}
                            {/* <li>
                          <Link
                            to="/european-hpi"
                            className={
                              activeIndex === "EUROPEAN HPI CHECKS"
                                ? "active"
                                : ""
                            }
                            onClick={() => {
                              handleItemClick("EUROPEAN HPI CHECKS");
                            }}
                          ></Link>
                          <div
                            className={`dropdown ${
                              activeItem === "EUROPEAN HPI CHECKS"
                                ? "active"
                                : ""
                            }`}
                            onClick={() => {
                              handleDropdownClick("EUROPEAN HPI CHECKS");
                              ToggleSidebar();
                            }}
                          >
                            <div className="dropdown__text">
                              EUROPEAN HPI CHECKS
                            </div>
                            {activeItem === "EUROPEAN HPI CHECKS" && (
                              <div className="dropdown__items">
                                <div className="dropdown__item">
                                  <Link to="/order-spanish">
                                    ORDER A SPANISH HPI CHECK
                                  </Link>
                                </div>
                                <div className="dropdown__item">
                                  <Link to="/order-french">
                                    ORDER A FRENCH HPI CHECK
                                  </Link>
                                </div>
                              </div>
                            )}
                          </div>
                        </li> */}
                        <li>
                              <Link
                                to="/car-listing"
                                className={
                                  activeIndex === "Car Listing" ? "active" : ""
                                }
                                onClick={() => {
                                  handleItemClick("Car Listing");
                                  ToggleSidebar();
                                  window.scrollTo(0, 0);
                                }}
                              >
                                CAR LISTING
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="/sell"
                                className={
                                  activeIndex === "Sell" ? "active" : ""
                                }
                                onClick={() => {
                                  handleItemClick("Sell");
                                  ToggleSidebar();
                                  window.scrollTo(0, 0);
                                }}
                              >
                                SELL
                              </Link>
                            </li>
                            <li>
                              {/* <Link
                                to="/about"
                                className={
                                  activeIndex === "About" ? "active" : ""
                                }
                                onClick={() => {
                                  handleItemClick("About");
                                  ToggleSidebar();
                                }}
                              >
                                ABOUT US
                              </Link> */}
                              <div
                                className={`dropdown ${activeItem === "About" ? "active" : ""
                                  }`}
                                onClick={() => handleDropdownClick("About")}
                              >
                                <div className="dropdown__text">
                                  <Link
                                    to="/about"
                                    className={
                                      activeIndex === "About" ? "active" : ""
                                    }
                                    onClick={() => {
                                      handleItemClick("About");
                                      ToggleSidebar();
                                    }}
                                  >
                                    ABOUT US
                                  </Link>
                                </div>
                                {activeItem === "About" && (
                                  <div className="dropdown__items">
                                    <div className="dropdown__item">
                                      <Link
                                        to="/about-history"
                                        onClick={() => {
                                          handleItemClick("ABOUT HISTORY");
                                          ToggleSidebar();
                                        }}
                                      >
                                        OUR HISTORY
                                      </Link>
                                    </div>
                                    <div className="dropdown__item">
                                      <Link
                                        to="/about-choose"
                                        onClick={() => {
                                          handleItemClick("About");
                                          ToggleSidebar();
                                        }}
                                      >
                                        WHY CHOOSE US
                                      </Link>
                                    </div>

                                    <div className="dropdown__item">
                                      <Link
                                        to="/about-testimonials"
                                        onClick={() => {
                                          handleItemClick("ABOUT TESTIMONIALS");
                                          ToggleSidebar();
                                        }}
                                      >
                                        TESTIMONIALS
                                      </Link>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </li>
                            <li>
                              <Link
                                to="/contact"
                                className={
                                  activeIndex === "Contact" ? "active" : ""
                                }
                                onClick={() => {
                                  handleItemClick("Contact");
                                  ToggleSidebar();
                                }}
                              >
                                CONTACT US
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="/blog-listing"
                                className={
                                  activeIndex === "blog-listing" ? "active" : ""
                                }
                                onClick={() => {
                                  handleItemClick("blog-listing");
                                  ToggleSidebar();
                                }}
                              >
                                BLOG LISTING
                              </Link>
                            </li>
                            {/* <li>
                              <div
                                className={`dropdown ${activeItem === "Blog Listing" ? "active" : ""
                                  }`}
                                onClick={() => {
                                  handleDropdownClick("Blog Listing");
                                  ToggleSidebar();
                                }}
                              >
                                <div className="dropdown__text">
                                  <Link
                                    to="/blog-listing"
                                    className={
                                      activeIndex === "Blog Listing"
                                        ? "active"
                                        : ""
                                    }
                                    onClick={() =>
                                      handleItemClick("Blog Listing")
                                    }
                                  >
                                    BLOG LISTING
                                  </Link>
                                </div>
                                {activeItem === "Blog Listing" && (
                                  <div className="dropdown__items">
                                    <div className="dropdown__item">
                                      <Link
                                        to="/blog-details"
                                        onClick={() => {
                                          handleItemClick("BLOG DETAILS");
                                          ToggleSidebar();
                                        }}
                                      >
                                        BLOG DETAILS
                                      </Link>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </li> */}
                            <li>
                              <div
                                className={`dropdown ${activeItem === "EUROPEAN HPI CHECKS"
                                  ? "active"
                                  : ""
                                  }`}
                                onClick={() => {
                                  handleDropdownClick("EUROPEAN HPI CHECKS");
                                  // ToggleSidebar();
                                }}
                              >
                                <div className="dropdown__text">
                                  EUROPEAN HPI CHECKS
                                </div>
                                {activeItem === "EUROPEAN HPI CHECKS" && (
                                  <div className="dropdown__items">
                                    <div className="dropdown__item">
                                      <Link
                                        to="/order-spanish"
                                        onClick={() => {
                                          handleItemClick(
                                            "EUROPEAN HPI CHECKS"
                                          );
                                          ToggleSidebar();
                                        }}
                                      >
                                        ORDER A SPANISH HPI CHECK
                                      </Link>
                                    </div>
                                    <div className="dropdown__item">
                                      <Link
                                        to="/order-french"
                                        onClick={() => {
                                          handleItemClick(
                                            "EUROPEAN HPI CHECKS"
                                          );
                                          ToggleSidebar();
                                        }}
                                      >
                                        ORDER A FRENCH HPI CHECK
                                      </Link>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </li>
                            <li>
                              <Link
                                to="/european-insurance"
                                className={
                                  activeIndex === "EUROPEAN INSURANCE"
                                    ? "active"
                                    : ""
                                }
                                onClick={() => {
                                  handleItemClick("EUROPEAN INSURANCE");
                                  ToggleSidebar();
                                }}
                              >
                                EUROPEAN INSURANCE
                              </Link>
                            </li>
                            <li>
                              <Link
                                to="/finance"
                                className={
                                  activeIndex === "FINANCE" ? "active" : ""
                                }
                                onClick={() => {
                                  handleItemClick("FINANCE");
                                  ToggleSidebar();
                                }}
                              >
                                FINANCE
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </nav>
                  </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-4 col-xs-4 col-0">
                  <div className="header-top-right">
                    <ul>
                      <li>
                        <Link
                          to={`mailto:${config?.Support_Email}`}
                          rel="noopener noreferrer"
                        >
                          <img src={gmailicon} alt="Email Support" />
                        </Link>
                      </li>
                      <li>
                        <Link to={`tel:${config && config?.Contact_Number}`}>
                          <img src={callicon} alt="" />
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="header-bottom">
            <div className="container">
              <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-12">
                  <div className="header-bottom-center">
                    <ul>
                      <li className="dropdown">
                        <Link
                          to="#"
                          className={
                            activeIndex === "EUROPEAN HPI CHECKS"
                              ? "active"
                              : ""
                          }
                        >
                          EUROPEAN HPI CHECKS
                        </Link>
                        <div className="dropdown-content">
                          <ul>
                            <li>
                              <Link to="/order-spanish">
                                ORDER A SPANISH HPI CHECK
                              </Link>
                            </li>
                            <li>
                              <Link to="/order-french">
                                ORDER A FRENCH HPI CHECK
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </li>
                      <li
                        className={
                          activeIndex === "EUROPEAN INSURANCE" ? "active" : ""
                        }
                        onClick={() => handleItemClick("EUROPEAN INSURANCE")}
                      >
                        <Link to="/european-insurance">EUROPEAN INSURANCE</Link>
                      </li>
                      <li
                        className={activeIndex === "FINANCE" ? "active" : ""}
                        onClick={() => handleItemClick("FINANCE")}
                      >
                        <Link to="/finance">FINANCE</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </>
      )}
    </div>
  );
}

export default Header;
